import { Component } from '@angular/core';
import { NetworkErrorService } from './modules/game/services/network-error.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'g-game';

  constructor(public networkErrorService: NetworkErrorService) {}
}
